import React from 'react';
import { Button } from '@mui/material';

function MUIButton(props) {
  const { variant = 'contained', title, sx, ...restProps } = props;
  return (
    <Button variant={variant}
      {...restProps}
      disableElevation
      size="small"
      sx={[{
        backgroundColor: '#7F56D9', color: '#fff', minWidth: '80px', textTransform: 'none', 
        fontWeight: 550, fontSize: '12px',
        borderRadius: '8px',
        height: '38px',
        "&:disabled": {
          backgroundColor: "#a789e8",
          color: "white",
          cursor: "not-allowed",
          pointerEvents: "auto"
        },
      }, { ...sx }]}>
      {title}
    </Button>
  )
};

export default MUIButton;
